module.exports = __webpack_public_path__ + "img/music-note-beamed.ef81325c.svg";